import api from './api.js';

export const adminService = {
    getStats: async () => {
        const response = await api.get('/admin/stats');
        return response.data.data;
    }
};


